import { render, staticRenderFns } from "./LegalEntityItem.vue?vue&type=template&id=bd8bf61e&scoped=true&"
import script from "./LegalEntityItem.vue?vue&type=script&lang=js&"
export * from "./LegalEntityItem.vue?vue&type=script&lang=js&"
import style0 from "./LegalEntityItem.vue?vue&type=style&index=0&id=bd8bf61e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8bf61e",
  null
  
)

export default component.exports